var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, props),
    React.createElement("path", { className: styles["oc-icon-burger-close"] || "oc-icon-burger-close", d: "M18 14l8.8-8.8c1.2-1 1.4-2.8.4-4.1-1-1.2-2.8-1.4-4.1-.4-.1.2-.2.3-.4.5L13.9 10 5.1 1.2C4 0 2.1 0 1 1.2S-.1 4.1 1 5.3L9.8 14 1 22.9C-.1 24-.1 25.9 1 27s3 1.1 4.1 0l8.8-8.8 8.8 8.8c1.2 1.1 3 1 4.1-.2 1-1.1 1-2.8 0-3.9L18 14z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Burger-close.svg